export const COLOUR_CODING_DISCLAIMER =
  'The colour coding for fertiliser index values is valid for arable and grassland crops only.'

export const MAGNESIUM_DISCLAIMER =
  'For cereals and grass at soil index 0 apply 50-100kgs MgO/ha every 3 to 4 years. For oilseeds at soil index 0 or 1 apply 50-100kg MgO/ha every 3 to 4 years.'

export const NO_CROP_INFORMATION =
  'Where no crop information is given, lime recommendations are provided for arable crops.'
